import type { UserToken } from "@src/app/types/Reactions";

const DEVICE_ID_KEY = "nuyou_device_id";

const EMPTY_TOKEN: UserToken = { type: null, id: null };

/**
 * Returns a stable per-browser device id, generating and persisting one on
 * first use. Client-only — returns null during SSR / when storage is blocked.
 */
export function getDeviceId(): string | null {
  if (typeof window === "undefined") return null;

  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;

    const id = window.crypto.randomUUID();
    window.localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    // Storage unavailable (private mode, blocked) — anonymous reactions can't
    // be tracked, so treat as no token.
    return null;
  }
}

export function getUserToken(): UserToken {
  const id = getDeviceId();
  if (!id) return EMPTY_TOKEN;
  return { type: "device_id", id };
}
